module.exports = "<md-switch \n\tng-model=\"inputCtrl.field.model\" \n\tng-disabled=\"inputCtrl.field.isDisabled\" \n\tng-true-value=\"1\" ng-false-value=\"0\"\n\tng-change=\"inputCtrl.ngChange()\"\n\taria-label=\"inputCtrl.field.label\">\n\t{{ inputCtrl.field.label | translate }}\n</md-switch>"


//////////////////
// WEBPACK FOOTER
// ./src/components/dinamic-inputs/inputSwitch/input-switch.html
// module id = 271
// module chunks = 0